<template>
  <div class="page-container">
    <div class="header">
      <div class="pss">
        <img src="@assets/actimg/pss.png" alt="" class="pssimg">
      </div>
      <div class="header_btn">
        <div class="jrdp" @click="showPopup = true">活动规则</div>
      </div>
    </div>
    <div class="banner">
      <div class="pro">
        <div class="pro_lis" @click="goDetail(158)">
          <div class="lis_img">
            <img src="https://bank.giftoceanmall.com/82d3b202603221731351262.png" alt="" class="pro1">
          </div>
          <div class="jt">
            <div class="jtimg">
              <img src="@assets/actimg/jiangjia.png" alt="" class="jiangjia">
            </div>
            <div class="jttext">限量直降300元</div>
            
          </div> 

          <div class="jtbtn">
              <div class="btn_price">
                <span style="font-size: 12px;">￥</span>
                <span style="font-size: 14px;">199</span>
                <span style="font-size: 12px;">.0</span>
              </div>
          </div>
        </div>
        <div class="pro_lis" @click="goDetail(163)">
          <div class="lis_img">
            <img src="https://bank.giftoceanmall.com/21ac1202603221730532733.jpg" alt="" class="pro1">
          </div>
          <div class="jt">
            <div class="jtimg">
              <img src="@assets/actimg/jiangjia.png" alt="" class="jiangjia">
            </div>
            <div class="jttext">限量直降200元</div>
            
          </div> 

         <div class="jtbtn">
              <div class="btn_price">
                <span style="font-size: 12px;">￥</span>
                <span style="font-size: 14px;">99</span>
                <span style="font-size: 12px;">.0</span>
              </div>
          </div>
        </div>
        <div class="pro_lis" @click="goDetail(53)">
          <div class="lis_img">
            <img src="@assets/actimg/pro3.png" alt="" class="pro1">
          </div>
          <div class="jt">
            <div class="jtimg">
              <img src="https://bank.giftoceanmall.com/ccf8f202603221732004489.png" alt="" class="jiangjia">
            </div>
            <div class="jttext">限量直降620元</div>
            
          </div> 

          <div class="jtbtn">
              <div class="btn_price">
                <span style="font-size: 12px;">￥</span>
                <span style="font-size: 14px;">179</span>
                <span style="font-size: 12px;">.0</span>
              </div>
          </div>
        </div>
        
      </div>
      
    </div>
    <div class="jrth">
      <span style="font-size: 24px;font-weight: bold;">今日特惠     </span>
      <span style="font-size: 18px;">10:00开抢</span>
    </div>
    <div class="product">
      <div class="product_title">
          捡漏专区
      </div>
      <div class="product_list">
        <div class="list_p" v-for="(item,index) in jlzq"  @click="goDetail(item.id)" style="margin-top: 5px;">
          <div class="p_img">
            <img :src="item.img" alt="" class="pp_img">
          </div>
          <div class="p_w">
            <div class="w_title">
              <span style="color: #6E4E1C;background-color: #FEDA67;padding: 5px; font-size: 10px;">分期免息</span>
              {{item.name}}
            </div>
            <div class="w_price">
              <div class="pri">
                <div>到手价</div>
                <div>￥{{item.price}}</div>
              </div>
              <div class="fenqi">
                <span style="font-size: 12px;font-weight: bold;">￥</span>
                <span style="font-size: 18px;font-weight: bold;">{{(item.price/12).toFixed(2)}}</span>
                <span style="font-size: 12px;">*12期</span>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="product">
      <div class="product_title">
          畅销爆款
      </div>
      <div class="product_list">
        <div class="list_p" v-for="(item,index) in cxbk"  @click="goDetail(item.id)" style="margin-top: 5px;">
          <div class="p_img">
            <img :src="item.img" alt="" class="pp_img">
          </div>
          <div class="p_w">
            <div class="w_title">
              <span style="color: #6E4E1C;background-color: #FEDA67;padding: 5px; font-size: 10px;">分期免息</span>
              {{item.name}}
            </div>
            <div class="w_price">
              <div class="pri">
                <div>到手价</div>
                <div>￥{{item.price}}</div>
              </div>
              <div class="fenqi">
                <span style="font-size: 12px;font-weight: bold;">￥</span>
                <span style="font-size: 18px;font-weight: bold;">{{(item.price/12).toFixed(2)}}</span>
                <span style="font-size: 12px;">*12期</span>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="product">
      <div class="product_title">
          数码特惠
      </div>
      <div class="product_list">
        <div class="list_p" v-for="(item,index) in smth"  @click="goDetail(item.id)" style="margin-top: 5px;">
          <div class="p_img">
            <img :src="item.img" alt="" class="pp_img">
          </div>
          <div class="p_w">
            <div class="w_title">
              <span style="color: #6E4E1C;background-color: #FEDA67;padding: 5px; font-size: 10px;">分期免息</span>
              {{item.name}}
            </div>
            <div class="w_price">
              <div class="pri">
                <div>到手价</div>
                <div>￥{{item.price}}</div>
              </div>
              <div class="fenqi">
                <span style="font-size: 12px;font-weight: bold;">￥</span>
                <span style="font-size: 18px;font-weight: bold;">{{(item.price/12).toFixed(2)}}</span>
                <span style="font-size: 12px;">*12期</span>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="product">
      <div class="product_title">
          家居特惠
      </div>
      <div class="product_list">
        <div class="list_p" v-for="(item,index) in jjth"  @click="goDetail(item.id)" style="margin-top: 5px;">
          <div class="p_img">
            <img :src="item.img" alt="" class="pp_img">
          </div>
          <div class="p_w">
            <div class="w_title">
              <span style="color: #6E4E1C;background-color: #FEDA67;padding: 5px; font-size: 10px;">分期免息</span>
              {{item.name}}
            </div>
            <div class="w_price">
              <div class="pri">
                <div>到手价</div>
                <div>￥{{item.price}}</div>
              </div>
              <div class="fenqi">
                <span style="font-size: 12px;font-weight: bold;">￥</span>
                <span style="font-size: 18px;font-weight: bold;">{{(item.price/12).toFixed(2)}}</span>
                <span style="font-size: 12px;">*12期</span>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="product">
      <div class="product_title">
          美妆特惠
      </div>
      <div class="product_list">
        <div class="list_p" v-for="(item,index) in mzth"  @click="goDetail(item.id)" style="margin-top: 5px;">
          <div class="p_img">
            <img :src="item.img" alt="" class="pp_img">
          </div>
          <div class="p_w">
            <div class="w_title">
              <span style="color: #6E4E1C;background-color: #FEDA67;padding: 5px; font-size: 10px;">分期免息</span>
              {{item.name}}
            </div>
            <div class="w_price">
              <div class="pri">
                <div>到手价</div>
                <div>￥{{item.price}}</div>
              </div>
              <div class="fenqi">
                <span style="font-size: 12px;font-weight: bold;">￥</span>
                <span style="font-size: 18px;font-weight: bold;">{{(item.price/12).toFixed(2)}}</span>
                <span style="font-size: 12px;">*12期</span>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="product">
      <div class="product_title">
          腕表特惠
      </div>
      <div class="product_list">
        <div class="list_p" v-for="(item,index) in wbth"  @click="goDetail(item.id)" style="margin-top: 5px;">
          <div class="p_img">
            <img :src="item.img" alt="" class="pp_img">
          </div>
          <div class="p_w">
            <div class="w_title">
              <span style="color: #6E4E1C;background-color: #FEDA67;padding: 5px; font-size: 10px;">分期免息</span>
              {{item.name}}
            </div>
            <div class="w_price">
              <div class="pri">
                <div>到手价</div>
                <div>￥{{item.price}}</div>
              </div>
              <div class="fenqi">
                <span style="font-size: 12px;font-weight: bold;">￥</span>
                <span style="font-size: 18px;font-weight: bold;">{{(item.price/12).toFixed(2)}}</span>
                <span style="font-size: 12px;">*12期</span>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
<div class="demo-page">
    <!-- 触发按钮 -->
   
    
    <!-- 弹出层组件 -->
    <MobilePopup 
      :visible="showPopup"
      @close="showPopup = false"
      content-width="90%"
      :border-radius="16"
    >
      <!-- 自定义弹出层内容 -->
     
    </MobilePopup>
  </div>
  </div>

   
</template>

<script>
import { goShopDetail } from "@libs/order";
import MobilePopup from './MobilePopup.vue'
export default {
  name: 'Activity1',
  components: {
    MobilePopup
  },
  data() {
    return {
      showPopup:false,
      jlzq:[
        {
          id:123,
          name:'海尔兄弟（HAIERBROS） 保温杯HB-BT101A',
          price:'19.9',
          oldprice:'39',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/01/20260122/91611e86ef5a50ebccaac7a270099d58.jpg',
        },
        {
          id:156,
          name:'罗莱腰腹揉腹按摩器LUOLAI-CLD100RF',
          price:'139',
          oldprice:'169',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/4c8dedcdb38c09cb1356d96565aa705b.png',
        },
        {
          id:162,
          name:'名创优品 MINISO 旅行洗漱便携收纳套装',
          price:'29',
          oldprice:'39',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/03/20260308/44965761c6a2abd4cc3823c89a1b1fc8.jpg',
        },
        {
          id:122,
          name:'海尔（Haier）即热开水机HL-EY101',
          price:'99',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/01/20260122/d0125c14b5f874731946bf25bb0c3460.jpg',
        },
        {
          id:50,
          name:'海尔（Haier）刀筷砧板消毒机  HY-SDK2G',
          price:'99',
          img:'https://bank.giftoceanmall.com/uploads/attach/2025/06/20250613/bb11affc7e4c2097a476e6d141c6a256.jpg',
        },
        {
          id:158,
          name:'海尔（Haier）多功能锅 DYG-MX4501A 红色',
          price:'199',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260227/007154134002bff2649674535dae966e.jpg',
        },
        {
          id:121,
          name:'海尔（Haier）电子冷暖（电子冰箱） HJU0-X602W00',
          price:'129',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/01/20260122/8881b6261a03994c9d4dd3f84293b84c.jpg',
        },
        {
          id:159,
          name:'海尔（Haier）单灯管旋钮款紫外线消毒器HBS-X03',
          price:'289',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260227/d2dd955ab7b614533b65dd52fc2303b1.jpg',
        },
        {
          id:163,
          name:'海尔（Haier）折叠调奶器（海尔联名款）BDC07HC',
          price:'99',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/03/20260308/7aa8a4b5b53ea19630e9d1f1582a6ad4.jpg',
        },
        
      ],
      cxbk:[
        {
          id:3,
          name:'海尔（Haier）空气炸锅 JL30D升级 3L',
          price:'189',
          img:'https://bank.giftoceanmall.com/uploads/attach/2025/05/20250522/17242ef6bb381daa0964e54053b95036.jpg',
        },
        {
          id:140,
          name:'海尔（Haier）电动牙刷 HTA2-HYB小摩刷 皓月白',
          price:'59',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/3afb0aef99f24a62475d86ee53d11ce9.jpg',
        },
        {
          id:141,
          name:'海尔剃须刀男士新款便携迷你官方正品小钢炮旅行电动刮胡刀 HSQ1-2218升级版',
          price:'59',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/07693b6f62dc06ae45b69302aa2ca419.jpg',
        },
        {
          id:53,
          name:'海尔（Haier）手持大吸力大功率轻盈机身高效除尘 真空吸尘器除螨仪HZ-C703R',
          price:'179',
          img:'https://bank.giftoceanmall.com/uploads/attach/2025/06/20250613/d047693c23116dfc65e21d10ff5c7669.jpg',
        },
        {
          id:39,
          name:'海尔吸尘器HT-C2160B有线手持吸猫毛小型推杆大吸力可视化尘杯',
          price:'129',
          img:'https://bank.giftoceanmall.com/uploads/attach/2025/06/20250611/76159d8d0d082b3fba369793c41a3b4c.jpg',
        },
      ],
      smth:[
         {
          id:157,
          name:'飞利浦（PHILIPS）骨传导概念耳夹式运动跑步蓝牙耳机长续航高端降噪',
          price:'199',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/7e8d32747a943fd9aee010bb31ffb4e4.jpg',
        },
        {
          id:153,
          name:'飞利浦（PHILIPS）真无线蓝牙耳机手机通话降噪运动跑步重低音音乐TAT1168',
          price:'199',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/f7c2f3d1aea8888ecd5d58120a820cce.jpg',
        },
        {
          id:135,
          name:'飞利浦3c认证磁吸magsafe充电宝便携迷你无线快充移动电源DLP9505 骑士灰 5000毫安',
          price:'119',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/784cab36b375c1ca2cc8dcdf0f75037d.jpg',
        },
        {
          id:155,
          name:'韶音（SHOKZ）OpenFit Air T511开放式耳机挂耳式蓝牙耳机黑/白',
          price:'419',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/c102c909bbdc02def578fb7ed93a55ea.jpg',
        },
        {
          id:154,
          name:'韶音（SHOKZ）OpenRun Air S803骨传导耳机黑/紫',
          price:'489',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/ed152b128939497a6777672e82580985.jpg',
        },
       
      ],
      jjth:[
        {
          id:129,
          name:'蔬果园家居清洁系列礼盒9件套A-22',
          price:'89',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/01/20260122/1a60aaf044ec2208a251e19805e67ac2.jpg',
        },
        {
          id:130,
          name:'蔬果园香雪苍兰香氛洗衣凝珠-8g*52颗',
          price:'22.9',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/01/20260122/cf62a2e2fc46fd891132615ffe8ee717.png',
        },
        {
          id:81,
          name:'SukGarden蔬果园橘彩星光果蔬餐具净1+1特惠装（半透瓶）800g*2',
          price:'22.9',
          img:'https://bank.giftoceanmall.com/uploads/attach/2025/09/20250924/d16c03f929a075582a5194f8a01a39b2.png',
        },
        {
          id:139,
          name:'公牛BULL TQU006盒装黑色大魔方插座(8979)3*1.0-1.8m',
          price:'79',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/60886d2fe05d8c62fa86a4f673b5640d.jpg',
        },
        {
          id:137,
          name:'公牛（BULL）S1120新国标插座 3位总控全长1.8米',
          price:'59',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/a5aabc3109c0e85471991228612e5682.jpg',
        },
        {
          id:138,
          name:'公牛BULL 218(S)吸塑装延长线插座(2459)3*1.0*5m*10H',
          price:'85',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/0b6d99f259451bd2fb18cc3241f13029.jpg',
        },
        
      ],
      mzth:[
        {
          id:151,
          name:'完美日记 仿生膜精华哑光口红 901',
          price:'109',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/6136d65f8160a53445c0f63b5b285f9b.jpg',
        },
        {
          id:150,
          name:'完美日记 氨基酸轻柔净澈卸妆水 500ml',
          price:'35',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/72fe685d2712eaceba73b77f0974e4d1.jpg',
        },
        {
          id:119,
          name:'完美日记 倾色慕光唇膏迷你套组 （升级版）',
          price:'74',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/01/20260122/6f8d9b2a6dbbcd7868af7292d186232a.jpg',
        },
        {
          id:120,
          name:'完美日记 恣意出色丝绒细管口红',
          price:'76',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/01/20260122/2d834a7e35c8a557f1b9e60002443f0b.jpg',
        },
      ],
      wbth:[
        {
          id:148,
          name:'TISSOT天梭 力洛克系列钢带机械手表男士腕表 T006.407.11.033.00',
          price:'4999',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/924dc2034292f00b3962a7b0092e3264.jpg',
        },
        {
          id:145,
          name:'Tissot天梭 嘉丽系列钢带机械女表刘亦菲同款情人节礼物(发光吧！小美人） T126.207.36.013.00',
          price:'5399',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/44c9be21987e981b6af0b3ebad6d8868.jpg',
        },
         {
          id:147,
          name:'Tissot天梭 魅时系列石英手表女士腕表 T143.210.17.091.00',
          price:'1899',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/00357558c351a232a977d77842d6a7b3.jpg',
        },
        {
          id:146,
          name:'Tissot天梭 力洛克系列机械手表男士腕表(黄晓明同款) T006.407.11.043.00',
          price:'4499',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/c9272fbdc64b5fbf303f25ffb0844dba.jpg',
        },
        {
          id:149,
          name:'TISSOT天梭 乐爱系列钢带石英女士腕表(19.5mm) T058.009.11.051.00',
          price:'2299',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/0e4039a40ffb763f43db54b0f8c05adb.jpg',
        },
       
      ],
    }
      
  },
  methods: {
    goDianpu() {
      
     
        this.$router.push({ path: "/"});
    
    },
    goDetail(id) {
      console.log(id);
      goShopDetail(id).then(() => {
        this.$router.push({ path: "/detail/" + id });
      });
    },
  }
}
</script>

<style scoped lang="scss">
.page-container{
  width: 100%;
  height: auto;
}
.header{
  width: 100%;
  height: 60px;
  background-color: #D73124;
  display: flex;
  justify-content: space-between;
  .pss{
    padding-left: 14px;
    padding-top: 17px;
    .pssimg{
      width: 70px;

    }
  }
  .header_btn{
    width: 111px;
    padding-top: 14px;
    // padding-right: 20px;
    .jrdp{
      width: 100px;
      height: 35px;
      line-height: 35px;
      text-align: center;
      background-color: #FEFAD6;
      border-radius: 5px;
      font-size: 18px;
      font-weight: 500;
      color: #EF1511;

    }
  }
  
}
.banner{
    width: 100%;
    height: 170px;
    background-color: #D73124;
    .pro{
      width: 95%;
      margin: 0 auto;
      height: 160px;
      background-color: #fff;
      border-radius: 0 0 10px 10px;
      display: flex;
      justify-content: space-around;
      .pro_lis{
        width: 100px;
        .lis_img{
          width: 100px;
          .pro1{
            width: 100px;
          }
        }
        .jt{
          width: 100px;
          display: flex;
          .jiangjia{
            width: 12px;
            // height: 27px;
          }
          .jttext{
            margin-left: 10px;
            color: #D73236;
            font-size: 10px;

          }
        }
        .jtbtn{
          width: 100px;
          height: 24px;
          background: url(../../assets/actimg/qiang.png) no-repeat;
          background-size: 100px;
          .btn_price{
            color: #D73236;
            font-weight: bold;
            line-height: 24px;
            padding-left: 6px;
          }
        }
      }
    }
}
.jrth{
  width: 100%;
  height: 60px;
  background: #D73124;
  text-align: center;
  line-height: 60px;
  color: #fff;
  margin-top: 5px;
}
.product{
  width: 100%;
  background: #f1f1f1;
  height: auto;
  .product_title{
    width: 100%;
    height: 60px;
    font-size: 18px;
    text-align: center;
    position: relative; /* 作为伪元素的定位参考 */
    padding-bottom: 6px; /* 文字和下划线的间距，可调整 */
    line-height: 60px;
    color: #D73124;
    font-weight: bold;
    display: inline-block; /* 关键：让容器宽度适配文字，否则会占满整行 */
    border-radius: 10px 10px 0 0;
  }
  .product_title::after{
    content: '';
    position: absolute;
    bottom: 9px; /* 下划线在文字底部 */
    left: 50%; /* 先把伪元素左侧定位到容器中点 */
    transform: translateX(-50%); /* 向左偏移自身50%，实现整体居中 */
    
    /* 自定义下划线样式 */
    width: 30px; /* 下划线长度，可自定义 */
    height: 3px; /* 下划线粗细 */
    background-color: #D73124; /* 下划线颜色 */
    border-radius: 2px; 
  }
}
.product_list{
  width: 100%;
  background: #f1f1f1;
  height: auto;
  .list_p{
    width: 95%;
    height: 140px;
    margin: 0 auto;
    background: #fff;
    border-radius: 5px;
    display: flex;
    .p_img{
      margin-top: 5px;
      width: 130px;
      height: 130px;
      margin-left: 5px;
      border-radius: 5px;
      .pp_img{
        width: 130px;
        height: 130px;
       
      }
    }
    .p_w{
      padding-top: 10px;
      padding-left: 5px;
      position: relative;
      .w_price{
        display: flex;
        width: 210px;
        margin-top: 30px;
        background: url(../../assets/actimg/price.png) no-repeat;
        background-size: 210px;
        height: 43px;
        position: absolute;
        bottom: 10px;
        // margin-left: 10px;
        .pri{
          color: #526079;
          font-size: 11px;
          margin-left: 5px;
          margin-top: 5px;

        }
        .fenqi{
          color: #D73124;
          margin-left: 20px;
          line-height: 43px;
        }
      }
    }
  }

}
.demo-page {
  padding: 20px;
}

.popup-demo-content {
  text-align: center;
}

button {
  padding: 8px 16px;
  background: #409eff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
</style>